// extracted by mini-css-extract-plugin
export default {"root":"UserNotes_root__B-XEe","textBox":"UserNotes_textBox__tlgvd"};